// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"6e20384a","94":"d60a54b9","238":"b4806fdc","414":"69679bde","541":"adcd2bff","574":"9af33e00","585":"5488cf90","612":"1cc9a9a3","717":"931a79e5","758":"791788a1","899":"5eb58b59","953":"f5e27173"}[chunkId] + ".chunk.js";
};